import translations from './translations.js';
const t = key => {
  return translations[key] || key;
};

export default t;
